import { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const DEFAULT_OWNER = {
  name: '',
  member_no: '',
  phone: '',
  from_date: '',
  to_date: '',
  note: '',
};

function parseJson(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try { return JSON.parse(value); } catch (err) { return []; }
}

export default function Owners({ member }) {
  const [owners, setOwners] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setOwners(parseJson(member?.previous_owners));
  }, [member]);

  const updateOwner = (index, key, value) => {
    setOwners(prev => {
      const next = [...prev];
      next[index] = { ...next[index], [key]: value };
      return next;
    });
  };

  const addOwner = () => setOwners(prev => [...prev, { ...DEFAULT_OWNER }]);
  const removeOwner = index => setOwners(prev => prev.filter((_, i) => i !== index));

  const save = async () => {
    if (!member?.id) { toast.error('Save personal info first'); return; }
    setSaving(true);
    try {
      await api.put(`/members/${member.id}`, { previous_owners: JSON.stringify(owners) });
      toast.success('Owner history saved');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  if (!member?.id) {
    return <div className="empty-state"><p>Save personal info first to manage owner history.</p></div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
      {owners.length === 0 && (
        <div className="empty-state"><p>No old owners recorded yet. Add the first owner entry below.</p></div>
      )}
      {owners.map((owner, index) => (
        <div key={index} className="card" style={{ padding: 18 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <h3 style={{ margin: 0, fontSize: 16 }}>Previous Owner {index + 1}</h3>
            <button className="btn btn-danger btn-sm" onClick={() => removeOwner(index)}>Remove</button>
          </div>
          <div className="grid-3">
            <div className="form-group">
              <label className="form-label">Owner Name</label>
              <input className="form-input" value={owner.name} onChange={e => updateOwner(index, 'name', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Member No</label>
              <input className="form-input" value={owner.member_no} onChange={e => updateOwner(index, 'member_no', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Phone</label>
              <input className="form-input" value={owner.phone} onChange={e => updateOwner(index, 'phone', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">From Date</label>
              <input className="form-input" type="date" value={owner.from_date} onChange={e => updateOwner(index, 'from_date', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">To Date</label>
              <input className="form-input" type="date" value={owner.to_date} onChange={e => updateOwner(index, 'to_date', e.target.value)} />
            </div>
            <div className="form-group" style={{ gridColumn: '1 / -1' }}>
              <label className="form-label">Notes</label>
              <textarea className="form-textarea" rows={3} value={owner.note} onChange={e => updateOwner(index, 'note', e.target.value)} />
            </div>
          </div>
        </div>
      ))}
      <button className="btn btn-secondary" onClick={addOwner}>+ Add Previous Owner</button>
      <div className="section-save-bar">
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Saving…' : 'Save Owner History'}
        </button>
      </div>
    </div>
  );
}
